/* Pylon calculation engine — pure functions, no DOM. */

/* ------------------------------------------------------------ reference data */

export const CE = [
  [15, 1.39, 1.06, 0.62], [20, 1.45, 1.13, 0.67], [25, 1.5, 1.19, 0.72],
  [30, 1.54, 1.23, 0.76], [40, 1.62, 1.31, 0.84], [60, 1.73, 1.43, 0.95],
  [80, 1.81, 1.53, 1.04], [100, 1.88, 1.61, 1.13], [120, 1.93, 1.67, 1.2],
  [160, 2.02, 1.79, 1.31], [200, 2.1, 1.87, 1.42], [300, 2.23, 2.05, 1.63],
  [400, 2.34, 2.19, 1.8],
];
export const EXP_COL = { D: 1, C: 2, B: 3 };

// QUIRK 1 — centroid→pressure band (Wind!K12:L26). A centroid in [lo,next) gets
// the pressure computed at the NEXT tabulated height. Conservative by design.
export const BANDS  = [0.1, 15, 20, 25, 30, 40, 60, 80, 100, 120, 160, 200, 300];
export const BAND_H = [15, 20, 25, 30, 40, 60, 80, 100, 120, 160, 200, 300, 400];

// QUIRK 2 — od/wall on each row belong to the section named on the PREVIOUS row.
// Load-bearing: slenderness looks up ACTUAL modulus against the LOOKUP-modulus
// breakpoints, landing one row low. The offsets cancel. Verified: 6" pipe
// d/t = 6.625/0.280 = 23.66. Straightening the table corrupts every ratio.
export const PIPE = [
  [0, null, null, null, null, null, null],
  [0.1, 1.72, '3"(.216)', 12, 2.23, null, null],
  [1.72, 2.39, '3.5"(.226)', 12, 2.68, 3.5, 0.216],
  [2.39, 3.21, '4"(.237)', 12, 3.17, 4, 0.226],
  [3.21, 5.45, '5"(.258)', 12, 4.3, 4.5, 0.237],
  [5.45, 8.5, '6"(.280)', 12, 5.58, 5.563, 0.258],
  [8.5, 16.8, '8"(.322)', 12, 8.4, 6.625, 0.28],
  [16.8, 29.9, '10"(.365)', 18, 11.91, 8.625, 0.322],
  [29.9, 43.8, '12"(.375)', 18, 14.58, 10.75, 0.365],
  [43.8, 53.2, '14"(.375)', 24, 16.05, 12.75, 0.375],
  [53.2, 70.3, '16"(.375)', 24, 18.41, 14, 0.375],
  [70.3, 89.6, '18"(.375)', 30, 20.76, 16, 0.375],
  [89.6, 111.3, '20"(.375)', 30, 23.12, 18, 0.375],
  [111.3, 135.4, '22"(.375)', 36, 25.48, 20, 0.375],
  [135.4, 161.9, '24"(.375)', 36, 27.83, 22, 0.375],
  [161.9, 190.6, '26"(.375)', 42, 30.19, 24, 0.375],
  [190.6, 221.8, '28"(.375)', 42, 32.54, 26, 0.375],
  [221.8, 254.8, '30"(.375)', 48, 34.9, 28, 0.375],
  [254.8, 291, '32"(.375)', 48, 37.26, 30, 0.375],
  [291, 329.2, '34"(.375)', 54, 39.61, 32, 0.375],
  [329.2, 370.2, '36"(.375)', 54, 41.97, 34, 0.375],
  [370.2, 506.1, '42"(.375)', 66, 49.04, 36, 0.375],
  [506.1, 668.37, '42"(.500)', 66, 65.19, 42, 0.375],
  [668.37, 984.73, '42"(.750)', null, 97.19, 42, 0.5],
  [984.73, null, "OVER RANGE", null, null, 42, 0.75],
];
export const TUBE = [
  [0, null, null, null, null, null, null],
  [0.1, 1.73, "TS3x3x.19", 12, 2.02, null, null],
  [1.73, 2.1, "TS3x3x.25", 12, 2.59, 3, 0.1875],
  [2.1, 3.3, "TS4x4x.19", 12, 2.77, 3, 0.25],
  [3.3, 4.11, "TS4x4x.25", 12, 3.59, 4, 0.1875],
  [4.11, 4.79, "TS4x4x.31", 12, 4.36, 4, 0.25],
  [4.79, 5.36, "TS5x5x.19", 12, 3.52, 4, 0.3125],
  [5.36, 6.78, "TS5x5x.25", 12, 4.59, 5, 0.1875],
  [6.78, 7.93, "TS6x6x.19", 12, 4.27, 5, 0.25],
  [7.93, 10.1, "TS6x6x.25", 12, 5.59, 6, 0.1875],
  [10.1, 11, "TS7x7x.19", 12, 5.02, 6, 0.25],
  [11, 14.6, "TS8x8x.19", 12, 5.77, 7, 0.1875],
  [14.6, 18.8, "TS8x8x.25", 12, 7.59, 8, 0.1875],
  [18.8, 22.7, "TS8x8x.31", 12, 9.36, 8, 0.25],
  [22.7, 26.4, "TS8x8x.37", 12, 11.1, 8, 0.3125],
  [26.4, 30.1, "TS10x10x.25", 18, 9.59, 8, 0.375],
  [30.1, 36.7, "TS10x10x.31", 18, 11.9, 10, 0.25],
  [36.7, 44.1, "TS12x12x.25", 18, 11.6, 10, 0.3125],
  [44.1, 54, "TS12x12x.31", 18, 14.4, 12, 0.25],
  [54, 63.4, "TS12x12x.37", 18, 17.1, 12, 0.3125],
  [63.4, 74.6, "TS14x14x.31", 24, 16.9, 12, 0.375],
  [74.6, 87.9, "TS14x14x.37", 24, 20.1, 14, 0.3125],
  [87.9, 98.6, "TS16x16x.31", 24, 19.4, 14, 0.375],
  [98.6, 116, "TS16x16x.37", 24, 23.1, 16, 0.3125],
  [116, 150, "TS16x16x.50", 24, 30.4, 16, 0.375],
  [150, null, "OVER RANGE", null, null, 16, 0.5],
];
export const FB_BASE = { P: 23100, TS: 30360 };
export const tableFor = (t) => (t === "P" ? PIPE : TUBE);
export const pickable = (t) => tableFor(t).filter((r) => r[1] !== null && r[5] !== null);

/* ------------------------------------------------------------------- engine */

export const num = (v) =>
  v === "" || v === null || v === undefined || isNaN(Number(v)) ? null : Number(v);

export function vlookupApprox(value, table) {
  if (value === null || value < table[0][0]) return null;
  let hit = null;
  for (const row of table) if (value >= row[0]) hit = row;
  return hit;
}

export function windTable(V, exposure, cq) {
  const qs = 0.00256 * V * V;
  const col = EXP_COL[exposure] - 1;
  return CE.map(([h, ...c]) => ({ h, qs, ce: c[col], cq, p: qs * c[col] * cq }));
}

// Returns the pressure basis at a centroid. Cq is applied per-area by the
// caller, because a round pole and a flat sign face take different shape
// factors from UBC table 16-H (0.8 vs 1.4).
export function pressureAt(y, table) {
  if (y === null) return { row: null, why: "centroid height is blank" };
  if (y < BANDS[0]) return { row: null, why: "centroid below 0.1 ft" };
  if (y >= 400) return { row: null, why: "centroid above the 400 ft table limit" };
  let i = 0;
  for (let k = 0; k < BANDS.length; k++) if (y >= BANDS[k]) i = k;
  return { row: table.find((r) => r.h === BAND_H[i]), band: BAND_H[i] };
}

// Default shape factor for an exposed structural column, UBC table 16-H.
export const CQ_COL = { P: 0.8, TS: 1.4 };

// Element vocabulary. Wind-wise every flat face behaves the same; the types
// exist so the inputs and the calc sheet speak the language of the drawing.
export const KINDS = {
  cabinet: { label: "Cabinet",         short: "Cabinet" },
  led:     { label: "LED display",     short: "LED" },
  reader:  { label: "Reader board",    short: "Reader" },
  cover:   { label: "Pole cover",      short: "Cover" },
  other:   { label: "Other panel",     short: "Panel" },
  column:  { label: "Exposed column",  short: "Column" },
};

// Old jobs stored a centroid and used "panel" for everything. Normalise to
// bottom-elevation positioning so nothing has to be re-entered by hand.
export function migrateAreas(list) {
  return (list || []).map((a) => {
    const kind = !a.kind || a.kind === "panel" ? "cabinet" : a.kind;
    let yb = a.yb;
    if (yb === undefined || yb === null) {
      const h = num(a.h), y = num(a.y);
      yb = kind === "column" ? "0" : h !== null && y !== null ? String(y - h / 2) : "";
    }
    return { desc: a.desc || "", kind, h: a.h ?? "", w: a.w ?? "", yb,
             cq: a.cq ?? "", wt: a.wt ?? "" };
  });
}

export function solveDepth({ h, P, q, b }) {
  if (!(h > 0 && P > 0 && q > 0 && b > 0)) return null;
  let D = 5;
  for (let i = 0; i < 300; i++) {
    const S1 = 2 * q * (D / 3);
    const A = (2.34 * P) / (S1 * b);
    const next = D + 0.5 * ((A / 2) * (1 + Math.sqrt(1 + (4.36 * h) / A)) - D);
    if (Math.abs(next - D) < 1e-12) { D = next; break; }
    D = next;
  }
  const S1 = 2 * q * (D / 3);
  return { D, S1, A: (2.34 * P) / (S1 * b) };
}

export function compute(j) {
  const V = num(j.basicSpeed), cqG = num(j.cq), sif = num(j.sif) || 1;
  const wt = V && cqG ? windTable(V, j.exposure, cqG) : null;

  // An exposed column's wind width is the OD of the section being selected,
  // which depends on the moment, which depends on that width. Circular. We
  // seed with no pole area and iterate to a fixed point.
  const baseType = (j.segments[0] && j.segments[0].type) || "P";
  const hasCol = j.areas.some((a) => a.kind === "column");

  const solve = (odIn) => {
    const blockers = [];
    if (!wt) blockers.push({ where: "Wind", msg: "Enter basic wind speed and Cq." });

    const areas = j.areas.map((a, i) => {
      const isCol = a.kind === "column";
      const H = num(a.h);
      // Sign drawings dimension from the bottom of an element. Centroid is derived.
      const YB = isCol && (a.yb === "" || a.yb === undefined) ? 0 : num(a.yb);
      const wCalc = isCol ? (odIn === null ? null : odIn / 12) : num(a.w);
      const yCalc = H !== null && YB !== null ? YB + H / 2 : null;
      const yTop = H !== null && YB !== null ? YB + H : null;
      const touched = !!(a.desc && a.desc.trim()) || a.h !== "" || a.yb !== "" ||
                      (!isCol && a.w !== "");
      const area = H !== null && wCalc !== null ? H * wCalc : null;
      const cqUse = num(a.cq) !== null ? num(a.cq)
                  : isCol ? CQ_COL[baseType] : cqG;
      const pr = wt && area !== null ? pressureAt(yCalc, wt)
                                     : { row: null, why: "wind inputs incomplete" };
      const p = pr.row ? pr.row.qs * pr.row.ce * cqUse : null;
      const ok = area !== null && yCalc !== null && p !== null;
      if (touched && !ok)
        blockers.push({
          where: `${KINDS[a.kind] ? KINDS[a.kind].label : "Area"} ${i + 1}${a.desc ? ` · ${a.desc}` : ""}`,
          msg: H === null ? (isCol ? "Enter the exposed height of the column." : "Enter the height.")
             : wCalc === null ? "Enter the width."
             : YB === null ? "Enter the bottom elevation."
             : pr.why,
        });
      return { ...a, i, isCol, wCalc, yCalc, yTop, yb: a.yb, area, y: yCalc, p, cqUse,
               wtLb: num(a.wt) || 0, band: pr.band, ok, touched };
    });

    const live = areas.filter((a) => a.ok && a.area > 0);
    const weighed = areas.filter((a) => a.wtLb > 0);
    const totalWt = weighed.reduce((t, a) => t + a.wtLb, 0);
    const anyLive = areas.some((a) => a.ok);
    const ready = anyLive && !areas.some((a) => a.touched && !a.ok);
    if (!anyLive && wt) blockers.push({ where: "Areas", msg: "Add at least one area subject to wind." });

    // Blank rows contribute nothing — the fix for the workbook's #N/A cascade.
    const Mg = ready ? live.reduce((s, a) => s + a.area * a.y * a.p, 0) : null;
    const Vg = ready ? live.reduce((s, a) => s + a.area * a.p, 0) : null;
    const sumA = live.reduce((s, a) => s + a.area, 0);
    const hBar = ready && sumA > 0 ? live.reduce((s, a) => s + a.area * a.y, 0) / sumA : null;
    const topEl = live.length ? Math.max.apply(null, live.map((a) => a.y + (num(a.h) || 0) / 2)) : null;

    const forcesAt = (y) =>
      !ready || y === null
        ? { M: null, V: null }
        : {
            M: live.reduce((s, a) => s + (y > a.y ? 0 : a.area * a.p * (a.y - y)), 0),
            V: live.reduce((s, a) => s + (y > a.y ? 0 : a.area * a.p), 0),
          };

    const segs = j.segments.map((sg, i) => {
      const n = num(sg.n) || 1;
      const s0 = num(sg.start);
      const enteredEnd = num(sg.end);
      // The pole never draws or extends past the top of the tallest sign
      // element — only the top-most segment can exceed it, so only that one
      // gets clamped. Computed fresh each time rather than stored, so it
      // tracks automatically if element heights change later.
      const isTopSeg = i === j.segments.length - 1;
      const capped = isTopSeg && topEl !== null && enteredEnd !== null && enteredEnd > topEl;
      const s1 = capped ? topEl : enteredEnd;
      const M = i === 0 ? Mg : forcesAt(num(j.segments[i - 1].end)).M;
      const Vv = i === 0 ? Vg : forcesAt(num(j.segments[i - 1].end)).V;
      const tbl = tableFor(sg.type);
      const base = { ...sg, i, n, s0, s1, M, V: Vv, capped, enteredEnd };

      if (M === null) return { ...base, state: "blocked", why: "Waiting on wind loads." };
      if (s0 === null || s1 === null) return { ...base, state: "blocked", why: "Enter start and end elevation." };
      if (s1 <= s0) return { ...base, state: "blocked", why: "End elevation must be above start." };

      const Sreq = (M * 12) / (FB_BASE[sg.type] * sif * n);

      let row;
      if (sg.mode === "manual" && sg.section) {
        row = tbl.find((rw) => rw[2] === sg.section);
        if (!row) return { ...base, Sreq, state: "blocked", why: "That section is not in the table." };
      } else if (sg.mode === "manual") {
        return { ...base, Sreq, state: "blocked", why: "Pick a section, or switch back to Auto." };
      } else {
        row = vlookupApprox(Sreq, tbl);
        if (!row || row[1] === null)
          return { ...base, Sreq, state: "blocked",
                   why: `Required modulus ${Sreq.toFixed(1)} in³ is past the largest section in the table.` };
      }
      const [, Sact, name, sleeve] = row;
      const fb = (M * 12) / (Sact * n * 1000);

      const sl = vlookupApprox(Sact, tbl); // QUIRK 2 — intentional
      const od = sl ? sl[5] : null, wall = sl ? sl[6] : null;
      if (od === null || wall === null)
        return { ...base, Sreq, Sact, name, sleeve, fb, state: "blocked", why: "No OD/wall data for this section." };

      let ratio, Fb, crit, label;
      if (sg.type === "P") {
        ratio = od / wall; crit = "d/t";
        Fb = (ratio < 94.29 ? 23.1 : 21) * sif;
        label = ratio < 94.29 ? "0.66Fy" : "0.60Fy";
      } else {
        ratio = (od - 3 * wall) / wall; crit = "b/t";
        if (ratio < 28.01) { Fb = 30.36 * sif; label = "0.66Fy"; }
        else if (ratio < 35.09) { Fb = 27.6 * sif; label = "0.60Fy"; }
        else return { ...base, Sreq, Sact, name, sleeve, fb, ratio, crit, state: "fail",
                      why: "Slender section — outside AISC-ASD 9th limits." };
      }
      const util = fb / Fb;
      const manualLight = sg.mode === "manual" && Sact < Sreq;
      return { ...base, Sreq, Sact, name, sleeve, fb, od, wall, ratio, crit, Fb, label, util,
               manualLight, state: util <= 1 ? "ok" : "fail",
               why: util <= 1 ? null : `fb ${fb.toFixed(2)} ksi exceeds Fb ${Fb.toFixed(2)} ksi.` };
    });

    return { areas, live, ready, blockers, Mg, Vg, hBar, topEl, forcesAt, segs,
             totalWt, weighed: weighed.length };
  };

  // ---- fixed point on the exposed-column width
  let od = 0, seen = [], colConverged = true, colIters = 0;
  let out = solve(od);
  if (hasCol) {
    for (colIters = 1; colIters <= 12; colIters++) {
      const s0 = out.segs.find((s) => s.od);
      const next = s0 ? s0.od : 0;
      if (Math.abs(next - od) < 1e-9) break;
      if (seen.indexOf(next) >= 0) {           // cycling between two sections
        od = Math.max.apply(null, seen.concat(next));
        out = solve(od); colConverged = false; break;
      }
      seen.push(next); od = next; out = solve(od);
    }
    if (colIters > 12) colConverged = false;
  }

  const { areas, live, ready, blockers, Mg, Vg, hBar, topEl, forcesAt, segs,
          totalWt, weighed } = out;

  // Element weights roll up into the footing bearing check unless overridden.
  const wtAuto = j.signWtMode !== "manual";
  const signWtUsed = wtAuto ? totalWt : (num(j.signWt) || 0);

  // seismic comparison (UBC 16-P) — reported, never applied automatically
  const Z = { 1: 0.075, 2: 0.2, 3: 0.3, 4: 0.4 }[num(j.seismicZone)] ?? null;
  const Fp = Z !== null ? Z * (num(j.impI) || 1) * (num(j.cp) || 2) * (num(j.wp) || 15) : null;
  const pMax = live.length ? Math.max.apply(null, live.map((a) => a.p)) : null;

  // ---- footing
  const nF = num(j.nFootings) || 1;
  const q = num(j.qLat);
  const round = j.footing === "round";

  // Column OD at grade — sourced from the base segment's actual selected
  // section unless the user overrides it. Keeps the concrete deduction and
  // the footing clearance check in sync with the column actually chosen,
  // instead of a hand-typed value that can drift out of step with it.
  const baseOD = segs.length && segs[0].od != null ? segs[0].od : null;
  const colWidthAuto = j.colWidthMode !== "manual";
  const cwUsed = colWidthAuto ? baseOD : num(j.colWidth);

  // Minimum clear cover between the embedded pole and the footing edge —
  // ACI 318-89 §7.7.1, concrete cast against and permanently exposed to
  // earth: 3 in minimum. This is a code floor, not a buildability margin;
  // shops often want more room to plumb and consolidate around the pole.
  const MIN_CLEAR_IN = 3;
  const minB = cwUsed !== null ? cwUsed / 12 + 2 * (MIN_CLEAR_IN / 12) : null;

  // Footing size: auto finds the smallest buildable size (0.5 ft steps)
  // that clears the pole and passes the bearing check at its own solved
  // depth. Bigger plan size means shallower required depth (UBC 1806.7)
  // and lower soil pressure, so the first passing size is the minimum.
  // Manual mode preserves existing jobs — and the golden corpus — exactly.
  const sizeAuto = j.footingSizeMode === "auto";
  const Mf = Mg === null ? null : Mg / nF;
  const P = Mf !== null && hBar ? Mf / hBar : null;
  const qAll = num(j.qBear);
  const stepD = num(j.depthStep) || 0.5;

  let W = num(j.pierW), L = num(j.pierL), dia = num(j.pierDia);
  let autoSized = false, autoSizeFailed = false;
  if (sizeAuto && P !== null && q && qAll) {
    // Practical floor, not just the code minimum: field practice sizes a
    // sign caisson at ~3x the pole OD (18 in minimum), so auto starts
    // there — in 6 in steps for augered holes, 0.5 ft for formed piers —
    // and the UBC 1806.7 solve + bearing check verify from that floor up.
    const odFt = cwUsed !== null ? cwUsed / 12 : 0;
    const practical = Math.max(round ? 2 : 1.5, 3 * odFt, minB !== null ? minB : 0);
    const stepS = round ? 0.5 : 0.5;
    const floor = Math.ceil(practical / stepS - 1e-9) * stepS;
    for (let s = floor; s <= 20 + 1e-9; s += stepS) {
      const bTry = round ? s : s * Math.SQRT2;          // rect auto is square, b = diagonal
      const sol = solveDepth({ h: hBar, P, q, b: bTry });
      if (!sol) break;
      const DuseTry = Math.max(2, Math.ceil(sol.D / stepD - 1e-9) * stepD); // 2 ft frost floor
      const areaTry = round ? Math.PI * Math.pow(s / 2, 2) : s * s;
      const qmaxTry = 150 * DuseTry + signWtUsed / nF / areaTry;
      const qfTry = Math.min(3, Math.pow(1.2, DuseTry)) * qAll;
      if (qfTry > qmaxTry) {
        if (round) { dia = s; W = null; L = null; }
        else { W = s; L = s; dia = null; }
        autoSized = true;
        break;
      }
    }
    if (!autoSized) autoSizeFailed = true;
  }

  const b = round ? dia : W && L ? Math.sqrt(W * W + L * L) : null;
  const undersized = minB !== null && b !== null && b < minB - 1e-9;

  let pier = null;
  if (P === null) {
    if (ready) blockers.push({ where: "Footing", msg: "Waiting on wind loads." });
  } else if (sizeAuto && autoSizeFailed) {
    blockers.push({ where: "Footing", msg:
      "No footing size up to 20 ft passes the bearing check. Check soil values." });
  } else if (!b || !q) {
    blockers.push({ where: "Footing", msg: sizeAuto
      ? "Enter lateral soil resistance and allowable bearing to size the footing."
      : round
      ? "Enter caisson diameter and lateral soil resistance."
      : "Enter pier width, length and lateral soil resistance." });
  } else {
    const sol = solveDepth({ h: hBar, P, q, b });
    const Dreq = sol.D;

    // Depth to build. Nobody digs to 3.90 ft — round up to the next increment.
    // Quantities and the bearing check both use the as-built depth.
    const autoUse = Math.ceil(Dreq / stepD - 1e-9) * stepD;
    const manualD = num(j.depthUse);
    const frostFloor = sizeAuto ? Math.max(2, autoUse) : autoUse;
    const Duse = j.depthMode === "manual" && manualD !== null ? manualD : frostFloor;
    const shallow = Duse < Dreq - 1e-9;

    const areaF = round ? Math.PI * Math.pow(dia / 2, 2) : W * L;
    const baseWt = areaF * Duse * 150;
    const qmax = (baseWt + signWtUsed / nF) / areaF;
    const qAll = num(j.qBear);
    const qf = qAll ? Math.min(3, Math.pow(1.2, Duse)) * qAll : null;

    /* ---- concrete take-off ------------------------------------------------
       DEVIATION from workbook: the round-caisson branch of Pier!E43 omits the
       square on the column radius (π·r·d instead of π·r²·d), over-deducting
       below 24" OD and under-deducting above it. Corrected here. The deduction
       is also capped at the footing depth — the workbook let a column embedded
       deeper than the footing displace concrete that was never poured.        */
    const cdAuto = j.colDepthMode === "auto";
    const cd = cdAuto ? Duse : num(j.colDepth);
    const haveCol = cwUsed !== null && cd !== null && cwUsed > 0;
    const grossCF = areaF * Duse;
    const dedCF = j.deductCol && haveCol
      ? Math.PI * Math.pow(cwUsed / 12 / 2, 2) * Math.min(cd, Duse) : 0;
    const netCF = grossCF - dedCF;
    const perCY = netCF / 27;
    const subCY = perCY * nF;
    const wPct = num(j.waste);
    const wasteCY = wPct !== null ? subCY * (wPct / 100) : 0;
    const withWaste = subCY + wasteCY;
    const rt = num(j.roundTo) || 0.25;
    const orderCY = Math.ceil(withWaste / rt - 1e-9) * rt;
    const truck = num(j.truckSize) || 10;

    // Embedment must fall within the footing's own depth range: at least
    // the required depth (UBC 1806.7 needs that much column in the ground
    // for the lateral bearing check to hold), and at most the build depth
    // (the column can't be embedded deeper than the hole is actually dug).
    const embedShallow = cd !== null && cd < Dreq - 1e-9;
    const embedDeep = cd !== null && cd > Duse + 1e-9;

    const concrete = {
      grossCF, dedCF, netCF, perCY, subCY, wPct, wasteCY, withWaste, orderCY, rt,
      loads: orderCY / truck, truck,
      noDeduct: j.deductCol && !haveCol,
      deductApplied: j.deductCol && haveCol,
    };

    pier = { ...sol, Dreq, Duse, autoUse, stepD, shallow, Mf, P, b, nF, areaF,
             baseWt, qmax, qf, concrete, cwUsed, colWidthAuto, minB, undersized, minClearIn: MIN_CLEAR_IN,
             embedShallow, embedDeep, colDepthEntered: cd, cdAuto,
             sizeAuto, autoSized, W, L, dia,
             vol: perCY, volTotal: subCY,
             state: qf === null ? "blocked" : qf > qmax ? "ok" : "fail",
             why: qf === null ? "Enter allowable bearing pressure."
                : qf > qmax ? null
                : `Soil pressure ${Math.round(qmax)} psf exceeds allowable ${Math.round(qf)} psf.` };
  }

  const checks = segs.map((s) => s.state).concat(pier ? pier.state : "blocked");
  const overall = checks.indexOf("fail") >= 0 ? "fail"
    : checks.every((c) => c === "ok") ? "ok" : "blocked";
  const govern = segs.filter((s) => s.state !== "blocked")
    .sort((a, b2) => (b2.util || 0) - (a.util || 0))[0] || null;

  return { wt, areas, live, ready, blockers, Mg, Vg, hBar, topEl, forcesAt, segs, pier,
           overall, govern, Fp, pMax, seismicGoverns: Fp !== null && pMax !== null && Fp > pMax,
           hasCol, colOD: od, colConverged, colIters,
           totalWt, weighed, wtAuto, signWtUsed };
}
